const months = [
  { id: 1, key: 'january', labelKey: 'january' },
  { id: 2, key: 'february', labelKey: 'february' },
  { id: 3, key: 'march', labelKey: 'march' },
  { id: 4, key: 'april', labelKey: 'april' },
  { id: 5, key: 'may', labelKey: 'may' },
  { id: 6, key: 'june', labelKey: 'june' },
  { id: 7, key: 'july', labelKey: 'july' },
  { id: 8, key: 'august', labelKey: 'august' },
  { id: 9, key: 'september', labelKey: 'september' },
  { id: 10, key: 'october', labelKey: 'october' },
  { id: 11, key: 'november', labelKey: 'november' },
  { id: 12, key: 'december', labelKey: 'december' }
]
const defaultDictionary = () => {
  return window.app.L10n || (key => key)
}
const monthsMap = months.reduce((map, item) => {
  map[item.id] = item
  return map
}, {})
const getMonthLabelByKey = (label, dictionary = defaultDictionary()) => {
  label = String(label).toLowerCase()
  const month = months.find(({ key }) => {
    return label === key
  })
  return month && dictionary(month.labelKey)
}
const getMonthByID = (id, dictionary = defaultDictionary()) => {
  id = parseInt(id)
  return monthsMap[id]
}
const getMonthLabelByID = (id, dictionary = defaultDictionary()) => {
  id = parseInt(id)
  return monthsMap[id] && dictionary(monthsMap[id].labelKey)
}
const getMonthLabels = (dictionary = defaultDictionary()) => {
  return months.map(({ labelKey }) => dictionary(labelKey))
}
export {
  months,
  monthsMap,
  getMonthByID,
  getMonthLabelByID,
  getMonthLabelByKey,
  getMonthLabels
}
